import { proxy } from "valtio";
import { devtools } from "valtio/utils";

import type { ModeOfSaleRow } from "./orchestrator";

const ENV_DEV = "dev";
const ENV_RECETTE = "recette";

type KitchenTicketStoreType = {
    noteKitchenTicketPrintNote: boolean;
    customerAddressModeSale: ModeOfSaleRow[];
    ticketKitchenModeSale: ModeOfSaleRow[];
    customerInformationModeSaleName: ModeOfSaleRow[];
    customerInformationModeSaleNumTel: ModeOfSaleRow[];
    customerInformationModeSaleAdress: ModeOfSaleRow[];
    customerInformationModeSaleCity: ModeOfSaleRow[];
    customerInformationModeSaleCode: ModeOfSaleRow[];
    customerInformationModeSaleCompany: ModeOfSaleRow[];
};

const KITCHEN_TICKET_DEFAULTS: KitchenTicketStoreType = {
    noteKitchenTicketPrintNote: false,
    customerAddressModeSale: [],
    ticketKitchenModeSale: [],
    customerInformationModeSaleName: [],
    customerInformationModeSaleNumTel: [],
    customerInformationModeSaleAdress: [],
    customerInformationModeSaleCity: [],
    customerInformationModeSaleCode: [],
    customerInformationModeSaleCompany: [],
};

export const kitchenTicketStore = proxy<KitchenTicketStoreType>({
    ...KITCHEN_TICKET_DEFAULTS,
});

if (
    process.env.REACT_APP_VERIFY === ENV_DEV ||
    process.env.REACT_APP_VERIFY === ENV_RECETTE
) {
    devtools(kitchenTicketStore);
}

export function setNoteKitchenTicket(value: boolean): void {
    kitchenTicketStore.noteKitchenTicketPrintNote = value;
}
export function setKitchenCustomerAddressModeSale(
    value: ModeOfSaleRow[]
): void {
    kitchenTicketStore.customerAddressModeSale = value;
}
export function setTicketKitchenModeSale(value: ModeOfSaleRow[]): void {
    kitchenTicketStore.ticketKitchenModeSale = value;
}
export function setCustomerInformationModeSaleName(
    value: ModeOfSaleRow[]
): void {
    kitchenTicketStore.customerInformationModeSaleName = value;
}
export function setCustomerInformationModeSaleNumTel(
    value: ModeOfSaleRow[]
): void {
    kitchenTicketStore.customerInformationModeSaleNumTel = value;
}
export function setCustomerInformationModeSaleAdress(
    value: ModeOfSaleRow[]
): void {
    kitchenTicketStore.customerInformationModeSaleAdress = value;
}
export function setCustomerInformationModeSaleCity(
    value: ModeOfSaleRow[]
): void {
    kitchenTicketStore.customerInformationModeSaleCity = value;
}
export function setCustomerInformationModeSaleCode(
    value: ModeOfSaleRow[]
): void {
    kitchenTicketStore.customerInformationModeSaleCode = value;
}
export function setCustomerInformationModeSaleCompany(
    value: ModeOfSaleRow[]
): void {
    kitchenTicketStore.customerInformationModeSaleCompany = value;
}

export function resetKitchenTicketStore(): void {
    Object.assign(kitchenTicketStore, KITCHEN_TICKET_DEFAULTS);
}
